export default function () {
  const widgetName = 'headerBackgroundWidget';
  const widgetOpts = headerBackgroundWidgetOpts;


  function addBackground(data) {
    const imgURL = data.items[0].ImageWithPath.toString();
     const headerHeight = $('header').height();
    $(`#${widgetName}`).remove();
    // get the height of .main-section and apply it to the background-size of .content when is the homepage
    if ($('body').hasClass('homepage')) {
      $('.main-section').css('background-image', `url('${imgURL}')`);
    } else {
      $('.wrapper').css(
        'background',
        `url('${imgURL}') center / cover no-repeat fixed`
      );
    }
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      addBackground(data);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
